/* jshint esversion: 11 */
import { createPinia, setActivePinia } from "pinia";
import piniaPluginpersist from "pinia-plugin-persist";

const store = createPinia();
setActivePinia(store);
// 使用持久化插件
store.use(piniaPluginpersist);
export default store;
